// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"XOVHxn_SyOo5b2sN"};